import { render, staticRenderFns } from "./ViolationMetricCard.vue?vue&type=template&id=60712e40&scoped=true"
import script from "./ViolationMetricCard.vue?vue&type=script&lang=js"
export * from "./ViolationMetricCard.vue?vue&type=script&lang=js"
import style0 from "./ViolationMetricCard.scss?vue&type=style&index=0&id=60712e40&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60712e40",
  null
  
)

export default component.exports